import { ReactNode } from 'react';
import styles from './EpStepContent.module.scss';

interface IStepContentRadioProps {
  children: ReactNode;
  visible?: boolean;
}

export const EpStepContentRadio = ({
  children,
  visible = true,
}: IStepContentRadioProps) => {
  if (!visible) return null;

  return <div className={styles['steps__radio']}>{children}</div>;
};
